// extracted by mini-css-extract-plugin
export var container = "_d5-0";
export var segment = "_d5-2";
export var segmentActive = "_d5-3";
export var track = "_d5-1";